import React from "react";

import "./InputField.scss";
import { Col, Row, Typography } from "antd";

interface DataInputFieldProps {
  label: React.ReactNode;
  children: React.ReactNode;
  itemScale?: {
    first: number;
    second: number;
  };
}

const InputField: React.FC<DataInputFieldProps> = ({
  label,
  children,
  itemScale = { first: 8, second: 16 },
  ...rest
}) => {
  const { first, second } = itemScale;
  return (
    <Row className="aadsadsad" {...rest} justify={"center"} align={"middle"}>
      <Col span={first}>
        <Typography.Text className="data-input-label" ellipsis={true}>
          {label}
        </Typography.Text>
      </Col>
      <Col span={second}>{children}</Col>
    </Row>
  );
};

export default InputField;
